const DateframeDropdownSelect = ({
  value,
  onChange,
  onChangeFunction,
  className = "",
}) => {
  const timeframeToDayConversionDict = {
    day: 1,
    week: 7,
    month: 30,
    "3 months": 90,
    "6 months": 182,
    year: 365,
  };

  const handleChange = (e) => {
    if (onChangeFunction) {
      onChangeFunction(e);
    } else if (onChange) {
      onChange(e.target.value);
    }
  };

  const baseClasses =
  "rounded text-black/75 bg-white py-1 sm:px-2 px-0 sm:text-center text-left";
  const combinedClassName = [baseClasses, className].filter(Boolean).join(" ");

  return (
    <select className={combinedClassName} value={value} onChange={handleChange}>
      <option value={"day"} className="text-base">
        Today (24 Hours)
      </option>
      <option value={"week"} className="text-base">
        This Week (7 days)
      </option>
      <option value={"month"} className="text-base">
        This Month (30 days)
      </option>
      <option value={"3 months"} className="text-base">
        Last 3 Months
      </option>
      <option value={"6 months"} className="text-base">
        Last 6 Months
      </option>
      <option value={"year"} className="text-base">
        Last Year
      </option>
    </select>
  );
};

export default DateframeDropdownSelect;
